'use client';
import React, { useEffect, useRef } from 'react';
import * as Styled from './styled';
import { RenderHeaderCellProps } from 'react-data-grid';
import { ColumnWithDType } from '../../types';
import { TRenderAsEnum } from '../../DataGrid/lib';
import TextareaAutosize from 'react-textarea-autosize';
import MaybeEvalStatus from '../MaybeEvalStatus';
import MarkdownViewer from '@/components/MarkdownViewer';

const THEME = 'chrome-devtools';

const DetailsEditor: React.FC<{ value: any; onChange: (value: string) => void }> = ({ value, onChange }) => {
  // const numLines = value.split('\n').length || 1;
  return (
    <TextareaAutosize
      style={{ width: '100%', padding: 10, border: 'none', borderRadius: 5, resize: 'none', background: 'none' }}
      value={value || ''}
      placeholder="NULL"
      onChange={(e) => onChange(e.target.value)}
    />
  );
};

export const Details: React.FC<
  React.HTMLAttributes<HTMLDivElement> & {
    field: ColumnWithDType;
    value: string;
    rootPath?: never;
    onChange?: (value: string | null) => void;
  }
> = ({ field, value, rootPath, onChange, ...rest }) => {
  const isNull = value === null || value === undefined;
  const isBlank = value === '';
  const isMultiline = !isNull && value?.includes('\n');

  const numLines = value.split('\n').length || 1;

  return onChange ? (
    <DetailsEditor value={value} onChange={onChange} />
  ) : (
    <Styled.Details {...rest}>
      <MarkdownViewer>{value}</MarkdownViewer>
      {/* <MaybeEvalStatus value={value}>
        <>
          {isBlank && <span className="blank-value">&nbsp;</span>}
          {isNull ? <span className="null-value">NULL</span> : isMultiline ? <pre>{value}</pre> : <span>{value}</span>}
        </>
      </MaybeEvalStatus> */}
    </Styled.Details>
  );
};

export const Cell: React.FC<
  React.HTMLAttributes<HTMLDivElement> & { field: ColumnWithDType; value: string; renderAs: TRenderAsEnum }
> = ({ field, value, renderAs, ...rest }) => {
  return (
    <Styled.Cell {...rest}>
      <MaybeEvalStatus value={value}>
        <span>{value?.toString().trim()}</span>
      </MaybeEvalStatus>
    </Styled.Cell>
  );
};

export const Header: React.FC<RenderHeaderCellProps<any> & { children: React.ReactNode }> = ({ children, ...rest }) => {
  const field = rest.column as ColumnWithDType;
  const displayName = field.name === '_oxen_row_id' ? '(idx)' : field.name;
  return (
    <Styled.Header>
      <div className="header-cell-name">{displayName}</div>
      {children}
    </Styled.Header>
  );
};
